import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import './PublicSellerStore.css';

const BASE = 'https://agro.atrmart.in/api';

const PublicSellerStore = () => {
    const { sellerId } = useParams(); // This will now catch "atrsolar" or "3"
    const [data, setData] = useState({ seller: null, products: [] });
    const [loading, setLoading] = useState(true);
    const [activeCategory, setActiveCategory] = useState('All');

    useEffect(() => {
        // Ensure your backend can handle the name string in this request
        axios.get(`${BASE}/api/seller-store/${sellerId}`)
            .then(res => {
                if (res.data.status) {
                    setData(res.data.data); 
                }
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [sellerId]);

    if (loading) return <div className="loader-container"><div className="loader"></div><p>Opening Store...</p></div>;
    if (!data.seller) return <div className="error-view"><h2>Store Not Found</h2><Link to="/agro">Return to Marketplace</Link></div>;

    // Extract unique categories for the mini-nav
    const categories = ['All', ...new Set(data.products.map(p => p.category))];
    const filteredProducts = activeCategory === 'All' 
        ? data.products 
        : data.products.filter(p => p.category === activeCategory);

    return (
        <div className="mini-site-wrapper">
            {/* 1. PROFESSIONAL HERO HEADER */}
            <header className="mini-site-header">
                <div className="header-overlay">
                    <div className="store-branding">
                        <div className="store-logo-circle">
                            {data.seller.business_name?.charAt(0)}
                        </div>
                        <div className="store-titles">
                            <h1>{data.seller.business_name}</h1>
                            <span className="badge-verified">✓ Authorized ATR Partner</span>
                        </div>
                    </div>
                </div>
            </header>

            {/* 2. MINI-NAV (Categories & Search) */}
            <nav className="mini-site-nav">
                <div className="category-scroll">
                    {categories.map(cat => (
                        <button 
                            key={cat} 
                            className={activeCategory === cat ? 'active' : ''}
                            onClick={() => setActiveCategory(cat)}
                        >
                            {cat}
                        </button>
                    ))}
                </div>
            </nav>

            {/* 3. MAIN PRODUCT GRID */}
            <main className="mini-site-content">
                <div className="section-title">
                    <h2>{activeCategory} Collection</h2>
                    <p>{filteredProducts.length} Products Available</p>
                </div>

                <div className="mini-product-grid">
                    {filteredProducts.map(product => (
                        <Link to={`/product/${product.id}`} key={product.id} className="mini-product-card">
                            <div className="img-container">
                                <img src={`${BASE}/storage/${product.image}`} alt={product.name} />
                                {product.mrp > product.price && <span className="off-tag">OFF</span>}
                            </div>
                            <div className="mini-card-info">
                                <h3>{product.name}</h3>
                                <div className="mini-price-row">
                                    <span className="current-price">₹{product.price}</span>
                                    {product.mrp > product.price && <span className="old-mrp">₹{product.mrp}</span>}
                                </div>
                                <button className="view-btn">View Details</button>
                            </div>
                        </Link>
                    ))}
                </div>
            </main>

            {/* 4. DETAILS FOOTER (The "Mini Website" feel) */}
            <footer className="mini-site-footer">
                <div className="footer-grid">
                    <div className="footer-col">
                        <h4>Contact Us</h4>
                        <p><i className="fas fa-phone"></i> {data.seller.mobile}</p>
                        <p><i className="fas fa-envelope"></i> {data.seller.email || 'Contact through ATR Mart'}</p>
                    </div>
                    <div className="footer-col">
                        <h4>Visit Store</h4>
                        <p><i className="fas fa-map-marker-alt"></i> {data.seller.address || data.seller.city}</p>
                        <p>{data.seller.city}, {data.seller.state} - {data.seller.pincode}</p>
                    </div>
                    <div className="footer-col">
                        <h4>Store Info</h4>
                        <p>GST: {data.seller.gst || 'Verified'}</p>
                        <p>Category: {data.seller.business_category}</p>
                    </div>
                </div>
                <div className="footer-bottom">
                    Powered by ATR Mart Marketplace
                </div>
            </footer>
        </div>
    );
};

export default PublicSellerStore;